import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip'; // ✅ THIS WAS MISSING

import { TranslateModule } from '@ngx-translate/core';
import Swal from 'sweetalert2';

import { CopyOrderDetail } from '@app/shared/CSDAModels/CopyOrderDetail';
import { Language } from '@app/core/enums/Language';
import { environment } from '@env';
import { FloatingTooltipDirective } from '@app/shared/components/floating-tooltip/floating-tooltip.directive';

@Component({
  selector: 'app-copy-order-dialog',
  standalone: true,
  templateUrl: './copy-order-dialog.component.html',
  styleUrls: ['./copy-order-dialog.component.scss'],
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    FloatingTooltipDirective,
  ],
})
export class CopyOrderDialogComponent {
  isProcessing = false;
  OrderID: number | null = null;
  IsCopyToLocal = false;

  constructor(
    private httpClient: HttpClient,
    private dialogRef: MatDialogRef<CopyOrderDialogComponent>,
  ) {}

  copyOrder() {
    this.isProcessing = true;

    const Detail: CopyOrderDetail = {
      Language: Language.English,
      IsDevelopmentEnvironment: false,
      OrderID: this.OrderID,
      IsCopyToLocal: this.IsCopyToLocal,
    };

    this.httpClient
      .post<string>(
        environment.CSDAEndPoint + '/CSDA/CopyOrderFromAzureToLocal',
        Detail,
      )
      .subscribe({
        next: (data) => {
          this.isProcessing = false;
          Swal.fire({
            icon: 'info',
            title: data,
            confirmButtonText: 'OK',
          }).then(() => this.dialogRef.close(true));
        },
        error: (error) => {
          this.isProcessing = false;
          Swal.fire({
            icon: 'error',
            title: error?.message ?? error,
            confirmButtonText: 'OK',
          });
        },
      });
  }
}
